<template>
  <div class="text-center" style="min-height: 160px; padding: 40px">
    <!-- TODO: Maybe try and make this look better -->
    <div class="pa-6">
      <v-progress-circular
        indeterminate
        color="learnicsGreen"
        size="64"
      ></v-progress-circular>
    </div>
    <div><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: 'AppSpinner',
  props: {},
  computed: {},
  methods: {},

  async mounted() {},
}
</script>

<style lang="scss" scoped>
.display-2 {
  font-family: 'Raleway', sans-serif !important;
}
</style>
